import type { FC } from "react";
import { useTranslation } from "react-i18next";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import { Button, Stack } from "@mui/material";
import { useAssistantNavigate } from "../model/assistantNavigation";
import { DEEP_LINK_KEYS } from "../model/labels";
import { isCabinetPath } from "../model/safeUrl";
import type { DeepLinkCard } from "../model/types";

/** «Смотреть подробнее»: разделы кабинета с фильтрами, собранными бэкендом (п. 4 спеки). */
export const DeepLinkButtons: FC<{ links: DeepLinkCard[] }> = ({ links }) => {
  const { t } = useTranslation();
  const navigate = useAssistantNavigate();
  const shown = links.filter(
    (l) => isCabinetPath(l.url) && DEEP_LINK_KEYS[l.kind] !== undefined
  );
  if (!shown.length) return null;
  return (
    <Stack direction="row" gap={1} flexWrap="wrap" sx={{ mt: 1.25 }}>
      {shown.map((l) => (
        <Button
          key={l.url}
          size="small"
          variant="outlined"
          endIcon={<ArrowForwardRounded />}
          onClick={() => navigate(l.url)}
          sx={{ borderRadius: 999 }}
        >
          {t(DEEP_LINK_KEYS[l.kind])}
        </Button>
      ))}
    </Stack>
  );
};
